module.exports = __webpack_public_path__ + "img/fish.c5743542.png";